export const STORAGE_KEYS = {
  token: "dd_token",
  user: "dd_user",
  store: "dd_store",
};
